import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';

interface IConfirmationDialogData {
  action?: string | boolean;
  customMsg?: string;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  hideCancelButton?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  imports: [MatIconModule, MatDialogClose, MatButtonModule],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss',
})
export class ConfirmationDialog {
  readonly dialogRef = inject(MatDialogRef<ConfirmationDialog>);
  readonly dialogData = inject<IConfirmationDialogData>(MAT_DIALOG_DATA);
  readonly translate = inject(TranslateService);

  //readonly dialogData = model(this.data);

  get dialogTitle(): string {
    return (
      this.dialogData?.title ||
      this.translate.instant('confirmationDialog.title')
    );
  }

  get message(): string {
    if (this.dialogData?.message) {
      return this.dialogData.message;
    }

    if (this.dialogData?.action == 'delete') {
      return this.translate.instant('confirmationDialog.messages.delete');
    }

    if (this.dialogData?.action == false && !this.dialogData?.customMsg) {
      return this.translate.instant('confirmationDialog.messages.activate');
    }

    if (this.dialogData?.action == true) {
      return this.translate.instant('confirmationDialog.messages.deactivate');
    }

    if (!this.dialogData?.action && this.dialogData?.customMsg) {
      return this.dialogData.customMsg;
    }

    return this.translate.instant('confirmationDialog.messages.statusChange');
  }

  get confirmButtonText(): string {
    return (
      this.dialogData?.confirmText ||
      this.translate.instant('confirmationDialog.buttons.yes')
    );
  }

  get cancelButtonText(): string {
    return (
      this.dialogData?.cancelText ||
      this.translate.instant('confirmationDialog.buttons.no')
    );
  }

  get hideCancelButton(): boolean {
    return this.dialogData?.hideCancelButton === true;
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
